var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPairSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.32,
    height: 21.44,
    viewBox: "0 0 21.32 21.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-pair-search22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.8,11.5A10.2,10.2,0,1,1,11,21.7,10.18,10.18,0,0,1,.8,11.5Zm1.5,0a8.81,8.81,0,0,0,8.8,8.8,8.67,8.67,0,0,0,8.7-8.8,8.73,8.73,0,0,0-8.7-8.8A8.88,8.88,0,0,0,2.3,11.5Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,22.6l-1.9-2a.71.71,0,0,1,1-1l1.9,1.9a.67.67,0,0,1,0,1,.76.76,0,0,1-.5.2C21.2,22.8,21.1,22.7,20.9,22.6Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_45",
    "data-name": "Capa 45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,7.9A2.43,2.43,0,0,1,7.6,5.5,2.37,2.37,0,0,1,10,7.9a2.31,2.31,0,0,1-2.4,2.4A2.37,2.37,0,0,1,5.2,7.9Zm.6,0A1.8,1.8,0,1,0,7.6,6.1,1.79,1.79,0,0,0,5.8,7.9Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,14.5c0-1.5-1.5-2.6-3.3-2.6S4.3,13,4.3,14.5a.27.27,0,0,1-.3.3.27.27,0,0,1-.3-.3c0-1.8,1.8-3.3,3.9-3.3s3.9,1.5,3.9,3.3a.3.3,0,1,1-.6,0Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_46",
    "data-name": "Capa 46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,9.8a3.45,3.45,0,1,1,3.5,3.4A3.46,3.46,0,0,1,11.9,9.8Zm.9,0a2.55,2.55,0,1,0,2.5-2.6A2.63,2.63,0,0,0,12.8,9.8Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,18.9c0-2.6,2.4-4.7,5.5-4.7a11,11,0,0,1,1.8.2c.2.1.4.3.3.5s-.3.4-.5.3a7.72,7.72,0,0,0-1.5-.2c-2.6,0-4.7,1.8-4.6,3.8,0,.2-.2.5-.4.5C10.1,19.3,9.9,19.1,9.9,18.9Z",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.8 -1.3)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-0.8 -1.3)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-0.8 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPairSearch);
export default __webpack_public_path__ + "static/media/user-pair-search.8d6a62dc0348bea9d692daaa32370b99.svg";
export { ForwardRef as ReactComponent };